import React from "react";
import FASTable from "../../../../../components/Tables/FASTable";
import Cookies from "js-cookie";
import { useSelector } from "react-redux";
import { Loader } from "../../../../../components/Loader/Loader";
import { useTheme } from "../../../../../Themecontext/Themecontext";

export default function Monthly() {
  const { Colourdata } = useSelector((state) => state.ClientLogin);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;

  const { RecPayMonthdata } = useSelector(
    (state) => state.ReceivablePaybleSlice,
  );

  const getRows = RecPayMonthdata?.OutstandingData?.map((label, index) => ({
    // srNumber: index + 1,
    chart: true,
    acname: label.acname,
    AprBalAmt: label.AprBalAmt,
    MayBalAmt: label.MayBalAmt,
    JunBalAmt: label.JunBalAmt,
    JulBalAmt: label.JulBalAmt,
    AugBalAmt: label.AugBalAmt,
    SepBalAmt: label.SepBalAmt,
    OctBalAmt: label.OctBalAmt,
    NovBalAmt: label.NovBalAmt,
    DecBalAmt: label.DecBalAmt,
    JanBalAmt: label.JanBalAmt,
    FebBalAmt: label.FebBalAmt,
    MarBalAmt: label.MarBalAmt,
    Balance: label.Balance,
  }));

  const getColumns = [
    { label: "Chart", key: "charts", align: "center" },
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Ac Name",
      key: "acname",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Total Balance", key: "Balance", align: "right", format: true },
    { label: "Apr ", key: "AprBalAmt", align: "right", format: true },
    { label: "May ", key: "MayBalAmt", align: "right", format: true },
    { label: "Jun ", key: "JunBalAmt", align: "right", format: true },
    { label: "Jul ", key: "JulBalAmt", align: "right", format: true },
    { label: "Aug ", key: "AugBalAmt", align: "right", format: true },
    { label: "Sep ", key: "SepBalAmt", align: "right", format: true },
    { label: "Oct ", key: "OctBalAmt", align: "right", format: true },
    { label: "Nov ", key: "NovBalAmt", align: "right", format: true },
    { label: "Dec ", key: "DecBalAmt", align: "right", format: true },
    { label: "Jan ", key: "JanBalAmt", align: "right", format: true },
    { label: "Feb ", key: "FebBalAmt", align: "right", format: true },
    { label: "Mar ", key: "MarBalAmt", align: "right", format: true },
  ];

  if (RecPayMonthdata === "no" || RecPayMonthdata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }

  return (
    <div style={{ marginTop: "20px" }}>
      <div
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
        }}
      >
        <div
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
            padding: "14px",
            margin: 0,
          }}
        >
          <h2
            style={{
              fontSize: "18px",
              margin: 0,
              letterSpacing: "1px",
              fontWeight: "600",
            }}
          >
            MONTHLY
          </h2>
        </div>
        <FASTable
          data={getRows}
          columns={getColumns}
          externalTotals={RecPayMonthdata?.OutstandingTotal?.[0]}
        />
      </div>
    </div>
  );
}
